import { useGeoLocation } from '../providers/LocationProvider';
import { __ } from '../utils';
import { Stack, type StackProps, Tooltip } from '@presov.sk/presov-ui-react';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import React from 'react';

type Props = {
  size?: number;
} & StackProps;

const MissingLocationIndicator: React.FC<Props> = ({
  size = 36,
  sx,
  ...stackProps
}) => {
  const { locationStatus } = useGeoLocation();

  if (locationStatus !== 'UNAVAILABLE' && locationStatus !== 'DENY') {
    return null;
  }

  const getTooltipText = () => {
    if (locationStatus === 'DENY') {
      return __(
        'Máte zakázanú lokalizáciu. Je potrebné ju povoliť v nastaveniach prehliadača.',
      );
    }
    if (locationStatus === 'UNAVAILABLE') {
      return __('Lokalizáciu sa nepodarilo získať.');
    }
    return undefined;
  };

  return (
    <Tooltip title={getTooltipText()}>
      <Stack
        sx={{
          height: size,
          width: size,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => theme.palette.warning.main,
          borderRadius: '100%',
          cursor: 'help',
          ...sx,
        }}
        {...stackProps}
      >
        <LocationOffIcon sx={{ color: 'white', fontSize: size - 16 }} />
      </Stack>
    </Tooltip>
  );
};

export default MissingLocationIndicator;
